import A11yDialog from 'a11y-dialog';
var Handlebars = require("handlebars");

let template = {};

// Initialize Handlebars and bind modal triggers
function modalInit() {
    if ($('#handlebarsModal').length) {
        // Compile Handlebars template
        const source = document.querySelector("#handlebarsModal").innerHTML;
        template = Handlebars.compile(source);

        // Reattach click event with delegation
        $(document).off('click', '.handlebarsModalTrigger', processModalContent)
            .on('click', '.handlebarsModalTrigger', processModalContent);
    }
}

// Initialize A11yDialog for all modals
function initDialogs() {
    document.querySelectorAll('.modalContainer').forEach(function (thisDialog) {
        const id = thisDialog.id;
        const container = document.getElementById(id);
        const dialog = new A11yDialog(container);

        dialog.on('show', () => $('body').addClass('__modal'));
        dialog.on('hide', () => $('body').removeClass('__modal'));
    });
}

function processModalContent() {
    const context = JSON.parse(this.dataset.modalcontent);
    const html = template(context);

    // Update modal content
    const destination = document.querySelector(".handlebarsContent");
    destination.innerHTML = html;

    // Trigger the associated modal
    const modalId = this.getAttribute('data-a11y-dialog-show');
    const targetModal = document.getElementById(modalId);

    if (targetModal) {
        const modalInstance = new A11yDialog(targetModal);
        modalInstance.show();
    }
}

// Initialize everything on page load
$(document).ready(function () {
    modalInit();
    initDialogs();
});

// Reinitialize after DataTables reordering
$('.dataTable').on('change', function () {
    modalInit();   // Rebind event listeners
    initDialogs(); // Reinitialize modals
});
